import React from 'react';
import { Clock, MapPin, VideoCamera } from '@phosphor-icons/react';
import { formatTimestamp } from '../../../event-list/util';

function EventCard({
  width,
  height,
  eventName,
  url,
  eventDate,
  endDate,
  eventCity,
  onClick,
  eventSlug,
  eventType,
}) {

  const { monthAbbreviated, startDay, startTime, endTime } = formatTimestamp(eventDate, endDate);

  return (
    <div
      className="relative rounded-xl mb-5 bg-white shadow-md w-full md:w-[420px] min-h-[400px]  overflow-hidden text-left text-sm text-black font-general-sans border border-grey-10 cursor-pointer "
      style={{width, height}}
      onClick={onClick}
    >
      <div className="absolute top-[0px] left-[0px] filter blur-[18px] w-full h-240px" />
      <div className="w-full overflow-hidden flex flex-row items-start justify-start">
        <img
          className="flex-1 relative max-w-full w-full h-[240px] md:h-[240px] object-cover"
          alt={eventName}
          src={url}
        />
      </div>
      <div className="flex flex-col gap-5 px-4 py-2  w-full text-xl">
        <div className="tracking-[-0.5px] mt-3 font-semibold  ">
          {eventName.length > 40
            ? eventName.substring(0, 36) + '...' // turncate length.
            : eventName}
        </div>
        <div className="w-full flex flex-col items-start justify-start text-base text-secondary-grey">
          <div className="self-stretch  flex flex-col gap-4 items-start justify-start tracking-[-0.5px] truncate">
            <div className="flex gap-2">
              <Clock size={24}
                color={'#878787'} />
              {startTime ?? 'startTime'} <span>-</span> {endTime ?? 'endTime'}
            </div>
            <div className="flex gap-2">
              {' '}
              {eventType === 'online' ? (
                <>
                  <VideoCamera size={24} color={'#878787'} /> Online Event
                </>
              ) : (
                <>
                  <MapPin size={24} color={'#878787'} /> {eventCity ?? 'eventCity'}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute top-4 left-4 rounded-md bg-white shadow-sm flex flex-col p-1.5 mb-4 items-center justify-center gap-[2px] text-center text-primary border-[0.5px] border-solid border-date-stroke">
        <div className="relative tracking-[-1px] leading-[102.7%] font-semibold inline-block w-8">
          {monthAbbreviated}
        </div>
        <div className="relative text-xl tracking-[-1px] leading-[102.7%] font-semibold">
          {startDay}
        </div>
      </div>
    </div>
  );
}

export default EventCard;
